/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.featured-services-splide' ).length ) {
        $( '.featured-services-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '2rem',
            pagination: false,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );

          const bar = splide.root.querySelector( '.progress-bar' );

          splide.on( 'mounted move', function() {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( splide.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
